import cond from 'lodash/cond';
import get from 'lodash/get';

import addDays from 'date-fns/addDays';
import addMonths from 'date-fns/addMonths';
import startOfToday from 'date-fns/startOfToday';

import {
    DATE_OPTION,
    DATE_OPTION_DURATION,
    DATE_OPTION_DATES,
    DATE_DURATION_VALUE,
    DATE_DURATION_UNIT,
    DATE_DURATION_UNIT_DAYS,
    DATE_DURATION_UNIT_MONTHS,
    DATE_MAX,
    DATE_MIN,
} from 'common/entities/formNode/nodeConfig';

export function getDateRangeEffectiveLimits(config) {
    const dateOption = get(config, DATE_OPTION, null);

    const isDuration = () => dateOption === DATE_OPTION_DURATION;
    const isDates = () => dateOption === DATE_OPTION_DATES;

    const getDatesFromDuration = () => {
        const durationUnitFunctions = {
            [DATE_DURATION_UNIT_DAYS]: addDays,
            [DATE_DURATION_UNIT_MONTHS]: addMonths,
        };
        const dateDurationValue = get(config, DATE_DURATION_VALUE, null);
        const dateDurationUnit = get(config, DATE_DURATION_UNIT, null);

        return {
            before: durationUnitFunctions[dateDurationUnit](startOfToday(), dateDurationValue),
            after: null,
        };
    };

    const getDates = () => {
        const dateMax = get(config, DATE_MAX, null);
        const dateMin = get(config, DATE_MIN, null);

        return {
            before: dateMin && new Date(dateMin),
            after: dateMax && new Date(dateMax),
        };
    };

    return cond([
        [isDuration, getDatesFromDuration],
        [isDates, getDates],
        [() => true, getDates],
    ])();
}
